import BehaviorOperandTypes from '../../constants/behavior_operand_types';

import BehaviorOperand from './behavior_operand';
import BehaviorExpression from './behavior_expression';
import BehaviorFieldOperand from './behavior_field_operand';
import BehaviorValueOperand from './behavior_value_operand';

export const create = (behaviorOperandProps) => {
	const behaviorOperandClass = getModelClass(behaviorOperandProps.type);
	return new behaviorOperandClass(behaviorOperandProps);
};

export const getModelClass = (behaviorOperandType) => {
	switch(behaviorOperandType) {
		case BehaviorOperandTypes.EXPRESSION:
			return BehaviorExpression;
		case BehaviorOperandTypes.FIELD:
			return BehaviorFieldOperand;
		case BehaviorOperandTypes.VALUE:
			return BehaviorValueOperand;
		default:
			return BehaviorOperand;
	}
};

export default {
	create,
	getModelClass,
};
